export default {
    computed: {
        linkTarget() {
            if(this.href && this.href.startsWith('http') && !this.href.includes(window.location.host)) {
                return '_blank'
            }
            return null
        },
    },
}